import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const StyledCheckbox = styled.input`
  width: 20px;
  height: 20px;
  accent-color: #283618;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  color: #283618;
  font-size: 0.875rem;
  cursor: pointer;
`;

export const PrivacyLink = styled.a`
  color: #283618;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
